(ns hypnos.dme.tile.field.consult-mask-comfortable
  "Field indicating that mask was comfortable."
  (:require [hypnos.i18n :refer [tr]]))

;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
;;; field

(defn field
  ([state]
   (field state {:disabled false}))
  ([state {:keys [disabled] :or {disabled false}}]
   [:div.field.is-horizontal
    [:div.field-label.is-normal]
    [:div.field-body
     [:div.field
      [:label.switch.is-rounded
       [:input
        {:type      :checkbox
         :disabled  disabled
         :checked   (not (get-in @state [:patient :patient/last-consult :consult/mask-was-comfortable? :value]))
         :on-change (fn [e]
                      (let [old-value (get-in @state [:patient :patient/last-consult :consult/mask-was-comfortable? :value])
                            new-value (not (-> e .-target .-checked))
                            changed?  (or (get-in @state [:patient :patient/last-consult :consult/mask-was-comfortable? :dirty?])
                                          (not= new-value old-value))]
                        (swap! state assoc-in
                               [:patient :patient/last-consult :consult/mask-was-comfortable? :value]
                               new-value)
                        (swap! state assoc-in
                               [:patient :patient/last-consult :consult/mask-was-comfortable? :dirty?]
                               changed?)
                        (when new-value
                            (swap! state assoc-in
                                   [:patient :patient/last-consult :consult/issues]
                                   {:value    #{}
                                    :dirty?   false
                                    :touched? false}))))
         :on-focus  (fn [_]
                      (swap! state assoc-in
                             [:patient :patient/last-consult :consult/mask-was-comfortable? :touched?]
                             true))}]
       [:span.check.is-info]
       [:span.control-label (tr :ui.label/not-satisfied)]]]]]))
